export default __webpack_public_path__ + "static/media/Compliance.42fab3c7.png";